// extracted by mini-css-extract-plugin
export default {"FormGroupVertical":"FormGroupVertical__FormGroupVertical__ruNFr","label":"FormGroupVertical__label__kyVtg","FormActionsVertical":"FormGroupVertical__FormActionsVertical__mZH4s"};